// Which codes a coder may pick, read from the codebook the API returns, never from a list in the
// page. UT follows the speaker: teacher codes for a teacher's utterance, student codes for a
// student's, O (speaker 'both') for either; every UT code when the speaker is unknown. RC is the
// same set for every speaker. Order is the codebook's, never a model's.
export const utCodesFor = (codebook, speaker) => {
    const ut = codebook?.ut || [];
    if (speaker !== 'teacher' && speaker !== 'student') return ut;
    return ut.filter((entry) => entry.speaker === speaker || entry.speaker === 'both');
};

export const rcCodes = (codebook) => codebook?.rc || [];

export const codesFor = (codebook, dimension, speaker) =>
    dimension === 'ut' ? utCodesFor(codebook, speaker) : rcCodes(codebook);

// Codes of the other speaker, for the panel's footnote ("Student rows show Ry, Rs, Rq and O instead.")
export const otherSpeaker = (speaker) => (speaker === 'teacher' ? 'student' : speaker === 'student' ? 'teacher' : null);
